import { buildExportData as coreBuildExportData } from "@reciperoll/core";
import { store } from "../store/store";

// Web binding for the shared export builder — reads the web store's current state.
export function buildExportData(email?: string) {
  return coreBuildExportData(store.getState(), email);
}
